<template>
  <router-view />
</template>

<script>
export default {
  name: 'WreDashboard'
};
</script>
